let config = {
  api_url: process.env.REACT_APP_API_URL,
  jwt_store_key: "atlas_jwt_secret_storage",
  image_size_limit: 200,
  file_size_limit: 200,
  video_size_limit: 200,
};

export default config;
